import React from "react";
import { Box, Typography, Card } from "@mui/material";

const RecommendationsSection = ({ recommendations }) => {
  const has = recommendations && recommendations.length > 0;
  return (
    <Card
      sx={{
        p: has ? { xs: 2, sm: 3 } : 2, // Padding adjusts for different screen sizes
        borderRadius: 3,
        height: "100%",
        width: "100%",
        background: "#f0f7ff",
        boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
        border: "1px solid rgba(0,0,0,0.04)",
      }}
    >
      <Typography
        variant="h6"
        fontWeight={600}
        mb={2}
        sx={{
          fontSize: { xs: "1.2rem", sm: "1.5rem" }, // Adjust font size for small screens
        }}
      >
        Recommended for You
      </Typography>
      {!has ? (
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{
            textAlign: "center",
            opacity: 0.7,
            fontSize: { xs: "0.8rem", sm: "1rem" }, // Adjust text size on smaller screens
          }}
        >
          No recommendations at this time.
        </Typography>
      ) : (
        <Box component="ul" sx={{ listStyle: "none", p: 0, m: 0 }}>
          {recommendations.map((rec) => (
            <Box
              key={rec.id}
              component="li"
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mb={2}
              sx={{
                flexDirection: { xs: "column", sm: "row" }, // Stack items vertically on smaller screens
              }}
            >
              <Typography
                variant="body2"
                color="text.primary"
                sx={{
                  fontSize: { xs: "0.9rem", sm: "1rem" }, // Adjust text size
                  mb: { xs: 1, sm: 0 }, // Add margin-bottom on small screens for spacing
                }}
              >
                {rec.name}
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{
                  fontSize: { xs: "0.85rem", sm: "1rem" }, // Adjust price text size
                }}
              >
                ${rec.price}
              </Typography>
            </Box>
          ))}
        </Box>
      )}
    </Card>
  );
};

export default RecommendationsSection;
